document.addEventListener("DOMContentLoaded", function () {
  // Function to show the lightbox
  function showLightbox(imageUrl) {
    const lightbox = document.createElement("div");
    lightbox.classList.add("lightbox-container");

    const closeButton = document.createElement("span");
    closeButton.classList.add("close-button");
    closeButton.innerHTML = "x";

    const image = document.createElement("img");
    image.classList.add("lightbox-image");
    image.setAttribute("src", imageUrl);

    lightbox.appendChild(closeButton);
    lightbox.appendChild(image);
    document.body.appendChild(lightbox);

    // Close the lightbox and re-enable scrolling when clicking on the close button or outside the image
    function closeLightbox() {
      lightbox.remove();
      document.body.classList.remove("lightbox-open");
    }

    closeButton.addEventListener("click", closeLightbox);

    lightbox.addEventListener("click", (event) => {
      if (event.target === lightbox) {
        closeLightbox();
      }
    });

    // Disable scrolling when the lightbox is open
    document.body.classList.add("lightbox-open");
  }

  // Add click event listener to all gallery items
  const galleryItems = document.querySelectorAll(".gallery__item");
  galleryItems.forEach((item) => {
    item.addEventListener("click", (event) => {
      const popupImage = item.querySelector(".popup-image");
      const imageUrl = popupImage.getAttribute("src");
      showLightbox(imageUrl);

      console.log("test"); // This will be printed in the console when an image is clicked
    });
  });
});